<template>
  <el-container class="register" v-loading="loading">
    <el-aside class="aside" width="40%">
      <div class="aside-content">
        <h1 class="tit">Welcome to Youmi Platform of Publisher.</h1>
        <div class="steps">
          <h2 class="steps-tit">Now you are four steps away from high ECPC.</h2>
          <div class="step">
            <section class="step-container">
              <div class="step-left">
                <img class="st-icon" src="../../assets/img/st-icon1.png" alt="step1" />
                <span class="st-msg">Fill out the application form.</span>
              </div>
              <img class="st-icon-end" src="../../assets/img/step-1.png" />
            </section>
            <i class="icon-y-xiayibu next-step-icon"></i>
            <section class="step-container">
              <div class="step-left">
                <img class="st-icon" src="../../assets/img/st-icon2.png" alt="step2" />
                <span class="st-msg">Activate your account via email.</span>
              </div>
              <img class="st-icon-end" src="../../assets/img/step-2.png" />
            </section>
            <i class="icon-y-xiayibu next-step-icon"></i>
            <section class="step-container">
              <div class="step-left">
                <img class="st-icon" src="../../assets/img/st-icon3.png" alt="step3" />
                <span class="st-msg">Contact your business director.</span>
              </div>
              <img class="st-icon-end" src="../../assets/img/step-3.png" />
            </section>
            <i class="icon-y-xiayibu next-step-icon"></i>
            <section class="step-container">
              <div class="step-left">
                <img class="st-icon" src="../../assets/img/st-icon4.png" alt="step4" />
                <span class="st-msg">Get access to your account to earn money</span>
              </div>
              <img class="st-icon-end" src="../../assets/img/step-4.png" />
            </section>
          </div>
        </div>
      </div>
    </el-aside>
    <el-main class="content">
      <section class="header" :class="{ scroll: hasScroll === true }">
        <div class="logo">
          <a href="https://www.youmi.net/en/" target="_blank">
            <img src="../../assets/img/Ym-logo2x.png" alt="LOGO" class="logo-img" />
          </a>
        </div>
        <router-link to="/aff-login">
          <div class="login overlay-btn">
            <span>Login</span>
          </div>
        </router-link>
      </section>
      <section class="main">
        <el-scrollbar
          style="height: 100%;"
          ref="scrollbar"
          v-if="page_level === 1 || page_level === 2"
        >
          <div class="signup-title" v-if="page_level === 1 || page_level === 2">
            <h1>Sign Up</h1>
            <div class="page-num">
              <span class="num">{{ page_level }}/2</span>
              <span>{{ page_level === 1 ? 'Account Info' : 'Traffic Info (10)' }}</span>
            </div>
          </div>
          <el-form
            :model="regist"
            ref="registerForm"
            :rules="rules"
            v-show="page_level == 1"
            status-icon
            class="regist-form"
          >
            <div class="regist-layout">
              <el-form-item prop="account_type">
                <label class="form-label">Company/Individual</label>
                <el-select v-model="regist.account_type" @change="changeAccountType">
                  <el-option
                    v-for="item in account_type"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="contact_number" class="application-number">
                <label class="form-label">Contact Information</label>
                <el-input v-model="regist.contact_number">
                  <el-select
                    v-model="regist.contact_type"
                    slot="prepend"
                    placeholder="Application"
                    popper-class="app-select"
                    @change="changeContactType"
                    ref="contact_type"
                  >
                    <el-option
                      v-for="item in applications"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      <img
                        :src="item.src"
                        style="width: 16px;height: 16px;margin-right: 16px;vertical-align: -3px;"
                      />
                      <span>{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </el-input>
              </el-form-item>
              <el-form-item prop="company">
                <label class="form-label">{{ nameLabel }}</label>
                <el-popover placement="top-start" trigger="click" popper-class="company-popper">
                  <div class="company-tip">
                    <div class="title">
                      <i class="icon-y-warning mr-1"></i>
                      <span>Company name should match your bank account beneficiary name.</span>
                    </div>
                    <img src="../../assets/img/tip-2x.png" width="442" height="154" />
                  </div>
                  <el-input
                    name="company"
                    type="text"
                    v-model="regist.company"
                    slot="reference"
                  ></el-input>
                </el-popover>
              </el-form-item>
              <el-form-item prop="password">
                <label class="form-label">Password</label>
                <el-input
                  name="password"
                  id="regform-password"
                  type="password"
                  v-model="regist.password"
                ></el-input>
              </el-form-item>
              <el-form-item prop="country">
                <label class="form-label">Region</label>
                <el-select v-model="regist.country" filterable>
                  <el-option
                    v-for="item in country"
                    :key="item.code"
                    :label="item.code_name"
                    :value="item.code"
                  >
                    <span style="float: left; color: #8492a6; font-size: 13px">
                      ({{ item.code }}){{ item.name }}
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="integration_type">
                <label class="form-label">Integration Type</label>
                <el-select v-model="regist.integration_type">
                  <el-option
                    v-for="item in integrationTypeOptions"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="captcha">
                <label class="form-label">Verification Code</label>
                <el-input v-model="regist.captcha" name="captcha">
                  <template slot="append">
                    <img
                      id="reset_psw_captcha"
                      class="captcha-img"
                      @click="src = '/api/common/get-captcha/?' + Math.random()"
                      :src="src"
                      alt="captcha"
                      style="vertical-align: middle;width: 122px;"
                    />
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="email">
                <label class="form-label">Enterprise E-mail</label>
                <el-input v-model="regist.email" type="email"></el-input>
              </el-form-item>
              <el-form-item prop="invitation_code">
                <label class="form-label">
                  Invitation Code
                  <span style="color: #909399;">(Optional)</span>
                </label>
                <el-input v-model="regist.invitation_code" :disabled="ifReferrer"></el-input>
              </el-form-item>
            </div>
            <el-form-item prop="user_agreement">
              <el-checkbox-group v-model="user_agreement" class="user-agreement">
                <el-checkbox label="1" style="display: block;">
                  I'm over 18 years old
                </el-checkbox>
                <el-checkbox label="2" style="display: block;margin-left: 0;">
                  I agree to the
                  <a href="https://en.youmi.net/terms/" target="_blank">
                    Terms & Conditions of Youmi Website
                  </a>
                </el-checkbox>
                <el-checkbox label="3" style="display: block;margin-left: 0;">
                  I agree to receive promo emails&newsletters from Youmi
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-button class="next-btn overlay-btn" @click="nextPage()">Next</el-button>
          </el-form>

          <el-form
            :model="traffic_info"
            ref="trafficInfoForm"
            :rules="traffic_info_rules"
            v-show="page_level == 2 && regist.integration_type === 1"
            status-icon
            class="traffic-form"
          >
            <el-form-item prop="q1">
              <label class="question">{{ questions.q1 }}</label>
              <div class="answer">
                <el-radio-group v-model="traffic_info.q1">
                  <div class="answer-layout">
                    <el-radio label="Website/APP Owner">Website/APP Owner</el-radio>
                    <el-radio label="Affiliate/Media Buyer">Affiliate/Media Buyer</el-radio>
                    <el-radio label="Ad Network">Ad Network</el-radio>
                    <el-radio label="Affiliate Network">Affiliate Network</el-radio>
                  </div>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item prop="q2">
              <label class="question">{{ questions.q2 }}</label>
              <div class="answer">
                <el-checkbox-group v-model="traffic_info.q2">
                  <div class="answer-layout">
                    <el-checkbox label="Facebook"></el-checkbox>
                    <el-checkbox label="Native"></el-checkbox>
                    <el-checkbox label="In-app"></el-checkbox>
                    <el-checkbox label="Adwords"></el-checkbox>
                    <el-checkbox label="Email Traffic"></el-checkbox>
                    <el-checkbox label="Direct Pub"></el-checkbox>
                    <el-checkbox label="Pop"></el-checkbox>
                    <el-checkbox label="Mediabuy"></el-checkbox>
                    <el-checkbox label="Display"></el-checkbox>
                    <el-checkbox label="Web"></el-checkbox>
                    <el-checkbox label="Other"></el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item prop="q3">
              <label class="question">{{ questions.q3 }}</label>
              <el-select
                v-model="traffic_info.q3"
                multiple
                :multiple-limit="3"
                filterable
                style="display: block;width: 60%; min-width: 300px;"
              >
                <el-option
                  v-for="item in country"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                  <span style="float: left; color: #8492a6; font-size: 13px">
                    ({{ item.code }}){{ item.name }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="q4">
              <label class="question">{{ questions.q4 }}</label>
              <el-cascader
                :options="a4_options"
                :props="{ multiple: true }"
                collapse-tags
                :show-all-levels="false"
                v-model="traffic_info.q4"
                popper-class="q4_popper"
                style="display: block;width: 60%;min-width: 300px;"
              ></el-cascader>
            </el-form-item>
            <el-form-item prop="q5">
              <label class="question">{{ questions.q5 }}</label>
              <div class="answer">
                <el-radio-group v-model="traffic_info.q5">
                  <div class="answer-layout">
                    <el-radio label="Gaming (CPI/CPA)"></el-radio>
                    <el-radio label="Travel"></el-radio>
                    <el-radio label="Download"></el-radio>
                    <el-radio label="Mobile Content"></el-radio>
                    <el-radio label="Commerce"></el-radio>
                    <el-radio label="Smartlink"></el-radio>
                    <el-radio label="App (CPI)"></el-radio>
                    <el-radio label="Other"></el-radio>
                  </div>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item prop="q6">
              <label class="question">{{ questions.q6 }}</label>
              <el-input
                v-model="traffic_info.q6"
                type="textarea"
                :rows="3"
                style="display: block;width: 100%;"
              ></el-input>
            </el-form-item>
            <el-form-item prop="q7">
              <label class="question">{{ questions.q7 }}</label>
              <div class="answer">
                <el-radio-group v-model="traffic_info.q7">
                  <div class="answer-layout">
                    <el-radio label="<500"></el-radio>
                    <el-radio label="500-2000"></el-radio>
                    <el-radio label="2000-5000"></el-radio>
                    <el-radio label="5000-8000"></el-radio>
                    <el-radio label="8000-15000"></el-radio>
                    <el-radio label="15000-30000"></el-radio>
                    <el-radio label="大于30000"></el-radio>
                  </div>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item prop="q8">
              <label class="question">{{ questions.q8 }}</label>
              <div class="answer">
                <el-radio-group v-model="traffic_info.q8">
                  <div class="answer-layout">
                    <el-radio label="API"></el-radio>
                    <el-radio label="S2S"></el-radio>
                  </div>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item prop="q9">
              <label class="question">{{ questions.q9 }}</label>
              <el-input
                type="textarea"
                :rows="3"
                v-model="traffic_info.q9"
                style="display: block;width: 100%;"
              ></el-input>
            </el-form-item>
            <el-form-item prop="q10">
              <label class="question">{{ questions.q10 }}</label>
              <div class="answer">
                <el-radio-group v-model="traffic_info.q10">
                  <div class="answer-layout">
                    <el-radio label="Exhibition"></el-radio>
                    <el-radio label="Facebook"></el-radio>
                    <el-radio label="Peer Recommendation"></el-radio>
                    <el-radio label="Forum"></el-radio>
                    <el-radio label="LinkedIn"></el-radio>
                    <el-radio label="Search Engines"></el-radio>
                    <el-radio label="Twitter"></el-radio>
                    <el-radio label="Other"></el-radio>
                  </div>
                </el-radio-group>
                <el-form-item prop="other" v-if="traffic_info.q10 === 'Other'">
                  <el-input
                    type="textarea"
                    :row="2"
                    v-model="traffic_info.other"
                    style="margin: 8px 0;"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form-item>
          </el-form>

          <el-form
            :model="sdk_info"
            ref="sdkInfoForm"
            :rules="sdk_info_rules"
            v-show="page_level == 2 && (regist.integration_type === 2 || regist.integration_type === 6)"
            status-icon
            class="traffic-form"
          >
            <el-form-item prop="q1">
              <label class="question">{{ sdk_questions.q1 }}</label>
              <el-input
                v-model="sdk_info.q1"
                type="textarea"
                :rows="3"
                style="display: block;width: 100%;"
              ></el-input>
            </el-form-item>
            <el-form-item prop="q2">
              <label class="question">{{ sdk_questions.q2 }}</label>
              <el-input
                v-model="sdk_info.q2"
                type="textarea"
                :rows="3"
                style="display: block;width: 100%;"
              ></el-input>
            </el-form-item>
            <el-form-item prop="q3">
              <label class="question">{{ sdk_questions.q3 }}</label>
              <el-select
                v-model="sdk_info.q3"
                multiple
                :multiple-limit="3"
                filterable
                style="display: block;width: 60%; min-width: 300px;"
              >
                <el-option
                  v-for="item in country"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                  <span style="float: left; color: #8492a6; font-size: 13px">
                    ({{ item.code }}){{ item.name }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="q4">
              <label class="question">{{ sdk_questions.q4 }}</label>
              <el-input
                v-model="sdk_info.q4"
                type="textarea"
                :rows="3"
                style="display: block;width: 100%;"
              ></el-input>
            </el-form-item>
            <el-form-item prop="q5">
              <label class="question">{{ sdk_questions.q5 }}</label>
              <el-input
                v-model="sdk_info.q5"
                type="textarea"
                :rows="3"
                style="display: block;width: 100%;"
              ></el-input>
            </el-form-item>
            <el-form-item prop="q6">
              <label class="question">{{ sdk_questions.q6 }}</label>
              <div class="answer">
                <el-radio-group v-model="sdk_info.q6">
                  <div class="answer-layout">
                    <el-radio label="Exhibition"></el-radio>
                    <el-radio label="Forum"></el-radio>
                    <el-radio label="Peer Referral"></el-radio>
                    <el-radio label="Google"></el-radio>
                    <el-radio label="Youtube"></el-radio>
                    <el-radio label="LinkedIn"></el-radio>
                    <el-radio label="Facebook"></el-radio>
                    <el-radio label="Twitter"></el-radio>
                    <el-radio label="Other"></el-radio>
                  </div>
                </el-radio-group>
                <el-form-item prop="other" v-if="sdk_info.q6 === 'Other'">
                  <el-input
                    type="textarea"
                    :row="2"
                    v-model="sdk_info.other"
                    style="margin: 8px 0;"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item>
              <label class="question">{{ sdk_questions.q7 }}</label>
              <el-input
                v-model="sdk_info.q7"
                type="textarea"
                :rows="3"
                style="display: block;width: 100%;"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-scrollbar>
        <div class="sign-up-btn" v-show="page_level == 2">
          <el-row :gutter="gutter">
            <el-col :span="12">
              <el-button class="before-btn overlay-btn" @click="before">Before</el-button>
            </el-col>
            <el-col :span="12">
              <el-button class="confirm-btn overlay-btn" @click="signUp">Confirm</el-button>
            </el-col>
          </el-row>
        </div>

        <div v-if="page_level === 3" class="register-success">
          <h2>
            <i class="icon-y-success mr-1"></i>
            Successfully Registered!
          </h2>
          <img src="../../assets/img/succ-1.png" />
          <div>
            <div class="sub-tit">Check your email address:</div>
            <div class="email">{{ regist.email }}</div>
            <div class="content">
              We have sent you an email, please click the link in the email to activate your
              account. If you can't find the mail, please check the spam.
            </div>
          </div>
          <el-button type="primary" class="check-btn overlay-btn" @click="checkEmail">
            Go and Check
          </el-button>
          <a class="no-received" @click="page_level = 4">No email received?</a>
        </div>

        <div v-if="page_level === 4" class="no-mail">
          <h2>
            <i class="icon-y-yiwen1 mr-1"></i>
            No Mail Received?
          </h2>
          <div class="sub-tit">Try the following solutions:</div>
          <div class="content">
            <div>1. Please wait for a few minutes in case of network latency.</div>
            <div>2. Don't forget to check your junk email in case of spam filtering.</div>
            <div>3. Please double check your email address.</div>
            <div>
              4. Send again.
              <a @click="sendEmailAgain">Click here.</a>
            </div>
            <div>5. Contact us for help: 【contact@youmi.net】</div>
          </div>
          <router-link to="/aff-login" class="skip">
            <el-button type="primary" class="skip-btn overlay-btn">Skip and login</el-button>
          </router-link>
        </div>
      </section>
    </el-main>
  </el-container>
</template>

<script>
/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
import { getCookie, removeCookie } from 'tiny-cookie'

export default {
  data() {
    return {
      gutter: 32,
      page_level: 1,
      hasScroll: false,
      questions: {
        q1: '1.Specialization',
        q2: '2.What traffic types do you generally use for promotional purposes?',
        q3: '3.What are the top 3 countries you promote offers in?',
        q4: '4.What kind of models do you work most?',
        q5: '5.Please choose your preferred niche.',
        q6: '6.What Affiliate network do you currently work with?',
        q7: '7.How much monthly revenue do you generate with other networks? (Currency: $)',
        q8: '8.Which integration methods do you prefer to?',
        q9:
          '9.Please include any other information that YOUMI should know about you or your company. (Optional)',
        q10: '10.How do you learn about YOUMI?',
      },
      regist: {
        invitation_code: '',
        password: '',
        contact_type: 0,
        integration_type: '',
      },
      nameLabel: 'Company Name / Name Correctly',
      traffic_info: {
        q1: '',
        q2: [],
        q3: [],
        q4: [],
        q5: '',
        q6: '',
        q7: '',
        q8: '',
        q9: '',
        q10: '',
      },
      sdk_info: {
        q1: '',
        q2: '',
        q3: '',
        q4: '',
        q5: '',
        q6: '',
        q7: '',
      },
      sdk_questions: {
        q1: '1.APP Name',
        q2: '2.URL for App Store / Downloading',
        q3: '3.3 countries with the largest number of users',
        q4: '4.Category of APP',
        q5: '5.Any other Offerwall SDKs connected?If yes, which platform?',
        q6: '6.How do you learn about Youmi?',
        q7:
          '7.Please include any other information that Youmi should know about you or your company. (Optional)',
      },
      user_agreement: ['1', '2'],
      account_type: this.registData.account_type,
      a4_options: [
        {
          value: 'CPI',
          label: 'CPI',
          children: [
            { value: 'Game', label: 'Game' },
            { value: 'Tools', label: 'Tools' },
            { value: 'E-commerce', label: 'E-commerce' },
            { value: 'Other', label: 'Other' },
          ],
        },
        {
          value: 'CPA(SOI/DOI)',
          label: 'CPA(SOI/DOI)',
        },
        { value: 'Smartlink', label: 'Smartlink' },
        { value: 'Other', label: 'Other' },
      ],
      applications: [
        { label: 'Teams', value: 0, src: require('../../assets/img/Teams.png') },
        { label: 'WhatsApp', value: 2, src: require('../../assets/img/WhatsApp.png') },
        { label: 'Telegram', value: 4, src: require('../../assets/img/Telegram.png') },
        { label: 'Wechat', value: 6, src: require('../../assets/img/Wechat.png') },
        { label: 'LinkedIn', value: 3, src: require('../../assets/img/LinkedIn.png') },
        // { label: 'QQ', value: 1, src: require('../../assets/img/QQ.png') },
        // { label: 'Facebook', value: 5, src: require('../../assets/img/Facebook.png') },
      ],
      country: [],
      countrys: [],
      integrationTypeOptions: [{ code: 1, name: 'API/S2S' }, { code: 2, name: 'Offerwall SDK' }, { code: 6, name: 'Interactive Ads' }],

      rules: {
        account_type: [
          { required: true, message: 'Please select one item.', trigger: ['blur', 'change'] },
        ],
        contact_number: [
          { required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] },
        ],
        company: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        country: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        integration_type: [
          { required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] },
        ],
        password: [{ validator: this.validatePass, trigger: ['blur'] }],
        captcha: [
          {
            validator: this.verifyCaptcha,
            trigger: ['blur'],
          },
        ],
        email: [
          { required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] },
          { type: 'email', message: 'Please enter a correct email.', trigger: ['blur', 'change'] },
        ],
        user_agreement: [
          {
            validator: this.verifyUserAgreement,
            trigger: ['change'],
          },
        ],
      },

      traffic_info_rules: {
        q1: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        q2: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        q3: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        q4: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        q5: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        q6: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        q7: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        q8: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        q10: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        other: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
      },

      sdk_info_rules: {
        q1: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        q2: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        q3: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        q4: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        q5: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        q6: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
        other: [{ required: true, message: 'Can\'t be empty!', trigger: ['blur', 'change'] }],
      },

      ifReferrer: false,
      src: '/api/common/get-captcha/',
      loading: false,
    }
  },
  created() {
    if (!this.countrys.length) {
      this.$http.get('/api/common/get-countries-r/', {}).then(data => {
        this.countrys = data.list
        // 用于注册页面的国家选择,去掉global选项
        this.country = this.countrys.slice(0, this.countrys.length - 1)
      })
    }

    this.bindReferrer()
  },
  mounted() {
    this.headerScroll()
  },
  methods: {
    validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('please enter password'))
      } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[._0-9A-Za-z]{6,16}$/.test(value)) {
        callback(
          new Error('The password must be between 6-16 characters and include letters &numbers.')
        )
      } else {
        callback()
      }
    },
    verifyCaptcha(rule, value, callback) {
      let item = {}
      item.captcha = this.regist.captcha
      this.$http
        .post('/api/common/check-captcha/', item)
        .then(() => {
          callback()
        })
        .catch(error => {
          console.error(error)
          callback(new Error('wrong verification code'))
          if (this.page_level === 2) {
            this.notifyOpen('Error', 'Please enter valid verification code.', 'error')
          }
        })
    },
    verifyUserAgreement(rule, value, callback) {
      if (this.user_agreement.includes('1') && this.user_agreement.includes('2')) {
        callback()
      } else {
        callback(
          new Error(
            'In order to become a publisher, you must be at least 18 years old and acccept the Terms & Conditions of Youmi Website'
          )
        )
      }
    },
    bindReferrer() {
      let next = window.location.href.split('?')[1]
      if (next) {
        let invitation_code = next.split('invitation_code=')[1] || next.split('invited_code=')[1]
        if (invitation_code) {
          let referer = String(invitation_code)
          this.regist.invitation_code = referer
          this.ifReferrer = true
        }
      }
    },
    signUp() {
      this.loading = true
      let integration_type = this.regist.integration_type
      let promise_arr
      if (integration_type === 1) {
        let p1 = new Promise((resolve, reject) => {
          this.$refs['registerForm'].validate(valid => {
            if (valid) {
              resolve()
            } else {
              reject(new Error('validate fail'))
            }
          })
        })
        let p2 = new Promise((resolve, reject) => {
          this.$refs['trafficInfoForm'].validate(valid => {
            if (valid) {
              resolve()
            } else {
              reject(new Error('validate fail'))
            }
          })
        })
        promise_arr = [p1, p2]
      }
      if (integration_type === 2 || integration_type === 6) {
        let p1 = new Promise((resolve, reject) => {
          this.$refs['registerForm'].validate(valid => {
            if (valid) {
              resolve()
            } else {
              reject(new Error('validate fail'))
            }
          })
        })
        let p2_sdk = new Promise((resolve, reject) => {
          this.$refs['sdkInfoForm'].validate(valid => {
            if (valid) {
              resolve()
            } else {
              reject(new Error('validate fail'))
            }
          })
        })
        promise_arr = [p1, p2_sdk]
      }
      Promise.all(promise_arr)
        .then(() => {
          if (getCookie('csrftoken')) {
            removeCookie('csrftoken')
          }
          let questions
          if (integration_type === 1) {
            questions = this.collectApiQuestionsData()
          } else {
            questions = this.collectSdkQuestionsData()
          }
          this.regist.question = JSON.stringify(questions)
          this.$http
            .post('/accounts/register-r/', this.regist)
            .then(() => {
              this.loading = false
              this.page_level = 3
              window.gtag('event', 'registerSuccess', { event_category: 'register' })
            })
            .catch(error => {
              this.loading = false
              if (error.c === -1002) {
                this.notifyOpen(
                  'Error',
                  'Failed to create an account. A user already exists with this email address.',
                  'error'
                )
              } else if (error.c === -1031) {
                this.notifyOpen('Error', 'Please enter valid verification code.', 'error')
              } else {
                this.notifyOpen('Error', error.m || 'Time Out! Please try again.', 'error')
              }
              window.gtag('event', 'registerError', { event_category: 'register' })
            })
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
      window.gtag('event', 'signUpButtonClick', { event_category: 'btnClick' })
    },
    nextPage() {
      this.$refs['registerForm'].validate(valid => {
        if (valid) {
          this.page_level = 2
        }
      })
      window.gtag('event', 'nextButtonClick', { event_category: 'btnClick' })
    },
    checkEmail() {
      let mailAddress = this.regist.email.split('@')[1]
      if (mailAddress) {
        if (mailAddress === 'gmail.com') {
          mailAddress = 'google.com'
        }
        window.open(`http://mail.${mailAddress}`, '_blank')
      }
    },
    sendEmailAgain() {
      let params = {
        email: this.regist.email,
        template: 'account_active',
      }
      this.$http
        .post('/accounts/email-send/', params)
        .then(res => {
          this.notifyOpen()
        })
        .catch(err => {
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    changeContactType(value) {
      let path = this.applications.find(item => item.value === value).src
      this.$refs.contact_type.$el.children[0].setAttribute(
        'style',
        `background: url(${path}) no-repeat; background-size: 16px;background-position: 9px 16px;`
      )
    },
    headerScroll() {
      let scrollEl = this.$refs.scrollbar.wrap
      scrollEl.onscroll = () => {
        if (scrollEl.scrollTop > 0) {
          this.hasScroll = true
        } else {
          this.hasScroll = false
        }
      }
    },
    before() {
      this.page_level = 1
      window.gtag('event', 'beforeBtnClick', { event_category: 'btnClick' })
    },
    collectApiQuestionsData() {
      let q4 = this.traffic_info.q4
      let cpi = []
      let cpa = []
      let smartlink = ''
      let other = ''
      let q4_answer = ''
      for (let i = 0; i < q4.length; i++) {
        if (q4[i][0] === 'CPI') {
          cpi.push(q4[i][1])
        }
        if (q4[i][0] === 'CPA') {
          cpa.push(q4[i][1])
        }
        if (q4[i][0] === 'Smartlink') {
          smartlink = 'Smartlink'
        }
        if (q4[i][0] === 'Other') {
          other = 'Other'
        }
      }
      if (cpi.length > 0) {
        q4_answer = 'CPI:' + cpi.join()
      }
      if (cpa.length > 0) {
        q4_answer = q4_answer + '/CPA:' + cpa.join()
      }
      if (smartlink) {
        q4_answer = q4_answer + '/Smartlink'
      }
      if (other) {
        q4_answer = q4_answer + '/Other'
      }
      let q10_answer = ''
      if (this.traffic_info.other) {
        q10_answer = 'Other:' + this.traffic_info.other
      } else {
        q10_answer = this.traffic_info.q10
      }
      let question = [
        {
          q: this.questions.q1,
          a: this.traffic_info.q1,
        },
        {
          q: this.questions.q2,
          a: this.traffic_info.q2.join(),
        },
        {
          q: this.questions.q3,
          a: this.traffic_info.q3.join(),
        },
        {
          q: this.questions.q4,
          a: q4_answer,
        },
        {
          q: this.questions.q5,
          a: this.traffic_info.q5,
        },
        {
          q: this.questions.q6,
          a: this.traffic_info.q6,
        },
        {
          q: this.questions.q7,
          a: this.traffic_info.q7,
        },
        {
          q: this.questions.q8,
          a: this.traffic_info.q8,
        },
        {
          q: this.questions.q9,
          a: this.traffic_info.q9,
        },
        {
          q: this.questions.q10,
          a: q10_answer,
        },
      ]
      return question
    },
    collectSdkQuestionsData() {
      let q6_answer = ''
      if (this.sdk_info.other) {
        q6_answer = 'Other:' + this.sdk_info.other
      } else {
        q6_answer = this.sdk_info.q6
      }
      let question = [
        {
          q: this.sdk_questions.q1,
          a: this.sdk_info.q1,
        },
        {
          q: this.sdk_questions.q2,
          a: this.sdk_info.q2,
        },
        {
          q: this.sdk_questions.q3,
          a: this.sdk_info.q3,
        },
        {
          q: this.sdk_questions.q4,
          a: this.sdk_info.q4,
        },
        {
          q: this.sdk_questions.q5,
          a: this.sdk_info.q5,
        },
        {
          q: this.sdk_questions.q6,
          a: q6_answer,
        },
        {
          q: this.sdk_questions.q7,
          a: this.sdk_info.q7,
        },
      ]
      return question
    },
    changeAccountType() {
      if (this.regist.account_type === 1) {
        this.nameLabel = 'Full Name of Your Company'
      } else {
        this.nameLabel = 'Your Full Name'
      }
    },
  },
  watch:{
    'regist.integration_type'(newValue) {
      let str = "5.Any other Offerwall SDKs connected?If yes, which platform?"
      if(newValue === 6){
        str = "5.Have you integrated with any other ad monetization platforms? If so, which platforms specifically?"
      }
      this.$set(this.sdk_questions,'q5',str)
    },
  }
}
</script>

<style lang="scss">
.register {
  min-height: 100%;
  position: relative;
  display: flex;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  .aside {
    background: url(../../assets/img/bg-aff.jpg) no-repeat center center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    .aside-content {
      width: 480px;
      color: #ffffff;
      .tit {
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 32px 0;
        line-height: 32px;
      }
      .steps-tit {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        margin: 0 0 8px 0;
      }
      .steps-tit::before {
        content: '';
        display: inline-block;
        height: 16px;
        border-left: 4px solid #e30077;
        vertical-align: -3px;
        margin-right: 8px;
      }
      .step-container {
        width: 100%;
        height: 72px;
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 8px;
        box-sizing: border-box;
        padding: 12px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .step-left {
          display: flex;
        }
        .st-icon {
          width: 48px;
          height: 48px;
          margin-right: 16px;
        }
        .st-msg {
          font-weight: 600;
          height: 48px;
          display: inline-flex;
          align-items: center;
        }
        .st-icon-end {
          width: 40px;
          height: 40px;
        }
      }
      .next-step-icon {
        font-size: 37px;
        color: rgba(255, 255, 255, 0.3);
        margin: 4px 222px;
      }
    }
  }
  .content {
    padding: 0;
    background-color: #fafcff;
    margin-bottom: 0px;
    position: relative;
    .header {
      height: 40px;
      padding: 24px 40px 0 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40px;
      transition: all 0.4s ease;
      .logo {
        margin: 0 0 0 16px;
        .logo-img {
          width: 175px;
          height: 40px;
        }
      }
      a {
        text-decoration: none;
        padding: 0;
      }
      .login {
        width: 80px;
        height: 32px;
        border: 2px solid #1861f2;
        border-radius: 4px;
        background: #fff;
        color: #1861f2;
        font-size: 14px;
        font-weight: bold;
        line-height: 32px;
        text-align: center;
      }
      .login::before {
        background-color: #1861f2;
      }
    }
    .scroll {
      transition: padding 0.4s ease, margin-bottom 0.5s ease;
      padding: 8px 40px 8px 40px;
      box-shadow: 0px 4px 8px 0px rgba(33, 35, 41, 0.08);
      border: 1px solid rgba(235, 238, 245, 1);
      margin-bottom: 0;
    }
    .main {
      height: calc(100vh - 140px);
      .signup-title {
        display: flex;
        justify-content: space-between;
        color: #303133;
        margin: 0 96px 24px 96px;
        h1 {
          font-size: 38px;
          font-weight: 600;
          line-height: 46px;
          margin: 0;
        }
        .page-num {
          display: inline-flex;
          align-items: center;
          .num {
            color: #606266;
            width: 52px;
            height: 28px;
            line-height: 28px;
            border-radius: 14px;
            background: #ffffff;
            border: 1px solid rgba(225, 228, 235, 1);
            text-align: center;
            margin-right: 8px;
          }
        }
      }
      .regist-form,
      .traffic-form {
        margin: 0 96px 0 96px;
      }
      .sign-up-btn {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        width: calc(100% - 192px);
        padding: 16px 96px;
        border-top: 1px solid rgba(235, 238, 245, 1);
        background: #fafcff;
        z-index: 10;
      }
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
    }
  }
  .el-form-item.is-error .el-input__inner {
    border-color: #f56c6c !important;
  }
  .el-form-item.is-error .el-input__validateIcon {
    color: #f56c6c !important;
  }
  .regist-form {
    .el-input__inner {
      height: 48px;
      font-size: 16px;
    }
  }
  .el-input-group__prepend {
    .el-input {
      width: 142px;
    }
  }
  .el-input-group__append {
    padding: 0;
  }
  .el-input__suffix {
    font-size: 16px;
  }
  .user-agreement {
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #606266;
    }
    .el-checkbox__inner {
      width: 16px;
      height: 16px;
      &::after {
        left: 5px;
        top: 2px;
      }
    }
  }
  .form-label {
    display: inline-block;
    color: #606266;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
  }
  .question {
    display: inline-block;
    font-size: 16px;
    line-height: 24px;
    color: #606266;
    font-weight: 400;
    margin-bottom: 8px;
  }
  .before-btn {
    width: 100%;
    height: 48px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    color: #e30077;
    border: 2px solid #e30077;
    &:hover {
      background-color: #fff;
    }
  }
  .before-btn::before {
    background: #e30077;
  }
  .confirm-btn {
    width: 100%;
    height: 48px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background: #e30077;
    border: none;
  }
  .confirm-btn::before {
    background-color: rgba(255, 255, 255, 0.2);
  }
  .answer {
    box-sizing: border-box;
    width: 100%;
    padding: 12px 24px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background: #ffffff;
    margin-bottom: 8px;
    .el-radio-group {
      .el-radio {
        margin: 0 55px 0 0;
        display: inline-block;
        height: 32px;
        line-height: 32px;
      }
    }
    .el-checkbox {
      display: block;
      margin-right: 30px;
      margin-left: 0;
      height: 32px;
      line-height: 32px;
    }
    .el-select,
    .el-cascader {
      width: 50%;
    }
    .el-radio-group {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .regist-layout {
    width: 100%;
    display: grid;
    justify-content: space-between;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 32px;
  }
  .answer-layout {
    width: 100%;
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 160px);
    grid-column-gap: 10px;
  }
  .next-btn {
    width: calc((100% - 32px) / 2);
    height: 48px;
    background: #e30077;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    margin-top: 24px;
  }
  .next-btn::before {
    background-color: rgba(255, 255, 255, 0.2);
  }
  .application-number {
    .el-select {
      .el-input {
        background: url('../../assets/img/Teams.png') no-repeat;
        background-size: 16px;
        background-position: 9px 16px;
      }
      .el-input__inner {
        text-indent: 20px;
        border-color: transparent !important;
      }
      .el-input__icon.el-input__validateIcon {
        display: none;
        color: transparent !important;
      }
    }
  }
  .register-success {
    width: 464px;
    height: 542px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid rgba(235, 238, 245, 1);
    margin: 80px auto 0;
    box-sizing: border-box;
    padding: 0 32px;
    h2 {
      text-align: center;
      font-size: 30px;
      color: #303133;
      i {
        color: #77b300;
        font-size: 24px;
      }
    }
    img {
      display: block;
      width: 240px;
      height: 160px;
      margin: 24px auto 24px;
    }
    .sub-tit {
      color: #303133;
      font-weight: 600;
      line-height: 24px;
      margin-bottom: 4px;
    }
    .email {
      color: #1861f2;
      font-weight: 600;
      line-height: 24px;
      margin-bottom: 12px;
    }
    .content {
      color: #606266;
      line-height: 22px;
      margin-bottom: 24px;
    }
    .check-btn {
      width: 100%;
      height: 40px;
      background: #e30077;
      border-radius: 4px;
      border: none;
      margin-bottom: 8px;
      font-weight: bold;
    }
    .check-btn::before {
      background-color: rgba(255, 255, 255, 0.2);
    }
    .no-received {
      display: block;
      width: 125px;
      margin: 0 auto;
      color: #1861f2;
    }
  }
  .no-mail {
    width: 464px;
    height: 378px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid rgba(235, 238, 245, 1);
    margin: 150px auto 0;
    box-sizing: border-box;
    padding: 0 32px;
    h2 {
      text-align: center;
      font-size: 30px;
      color: #303133;
      i {
        color: #ff9933;
        font-size: 24px;
        vertical-align: 2px;
      }
    }
    .sub-tit {
      color: #303133;
      font-weight: 600;
      line-height: 24px;
    }
    .content {
      color: #606266;
      line-height: 22px;
      margin-bottom: 24px;
      a {
        color: #1861f2;
      }
    }
    .skip {
      width: 100%;
    }
    .skip-btn {
      width: 100%;
      height: 40px;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      border: none;
      border-radius: 4px;
      background: #1861f2;
    }
    .skip-btn::before {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
  @media screen and (max-width: 1280px) {
    .aside {
      display: none;
    }
  }
  @media screen and (max-width: 500px) {
    .aside {
      display: none;
    }
    .signup-title {
      margin: 0 30px 24px 30px !important;
    }
    .traffic-form {
      margin: 0 30px !important;
    }
    .sign-up-btn {
      width: calc(100% - 60px) !important;
      padding: 16px 30px !important;
    }
    .regist-form {
      margin: 0 30px !important;
      .regist-layout {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-column-gap: 0;
      }
    }
    .user-agreement {
      .el-checkbox {
        white-space: normal;
      }
      .el-checkbox__label {
        display: inline;
      }
    }
    .next-btn {
      width: 100%;
    }
  }
}
.company-popper {
  top: 40px !important;
  padding: 16px 24px;
  .company-tip {
    .title {
      color: #0080cb;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      border-bottom: 1px solid #ebeef5;
      padding-bottom: 16px;
      margin-bottom: 16px;
      i {
        color: #ff9933;
        font-size: 24px;
      }
    }
  }
}
@media screen and (max-width: 500px) {
  .company-popper {
    width: 300px !important;
  }
  .company-tip {
    img {
      width: 260px;
      height: 110px;
    }
  }
}
.q4_popper {
  .el-cascader-menu {
    min-width: 250px;
    background-color: #f6f8fb;
    height: 166px;
  }
  .el-scrollbar {
    overflow-x: hidden;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
}
</style>
